var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"fill-current",attrs:{"width":"20","height":"18","viewBox":"0 0 20 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17 4H20L16 0L12 4H15V18H17V4ZM0 14H10V16H0V14ZM4 2V4H0V2H4ZM0 8H7V10H0V8Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }